export const DEFAULT_MEMBERSHIP_LIMIT = 13_500
